import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const DeploymentIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.026 19.7118L4.77377 19.7118C3.44828 19.7118 2.37377 18.6372 2.37378 17.3117L2.37387 8.18742C2.37388 7.2735 2.37354 5.97177 2.37325 5.02922C2.37304 4.3663 2.91037 3.82953 3.57329 3.82953H9.29151L12.0565 6.78317H20.3728C21.0356 6.78317 21.5728 7.32042 21.5728 7.98317V11.1707M21.6268 17.7279L19.1725 20.1705M19.1725 20.1705L16.8268 17.8383M19.1725 20.1705V14.1705"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
};

DeploymentIcon.displayName = 'DeploymentIcon';
